/**
 * @generated SignedSource<<fb51c631564da0f889d81ae7154a9786>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateXeroExportDefaultsInput = {
  tenantId: string;
  projectInDescription: boolean;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateXeroExportDefaultsMutation$variables = {
  input: UpdateXeroExportDefaultsInput;
};
export type updateXeroExportDefaultsMutation$data = {
  readonly updateXeroExportDefaults: {
    readonly billFrom: {
      readonly id: string;
      readonly externalId: string;
      readonly integration: string;
      readonly exportProjectInDescription: boolean | null;
    } | null;
  } | null;
};
export type updateXeroExportDefaultsMutation = {
  variables: updateXeroExportDefaultsMutation$variables;
  response: updateXeroExportDefaultsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateXeroExportDefaultsPayload",
    "kind": "LinkedField",
    "name": "updateXeroExportDefaults",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BillFrom",
        "kind": "LinkedField",
        "name": "billFrom",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "integration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "exportProjectInDescription",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateXeroExportDefaultsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateXeroExportDefaultsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "65dc454771f18d1dc5a853253734001c",
    "id": null,
    "metadata": {},
    "name": "updateXeroExportDefaultsMutation",
    "operationKind": "mutation",
    "text": "mutation updateXeroExportDefaultsMutation(\n  $input: UpdateXeroExportDefaultsInput!\n) {\n  updateXeroExportDefaults(input: $input) {\n    billFrom {\n      id\n      externalId\n      integration\n      exportProjectInDescription\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2b0b48b49116a50039f903d4e011d90b";

export default node;
